module.exports = __webpack_public_path__ + "img/massive-dance-radio.a6b7d448.png";